exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".example-card {\n  max-width: 400px;\n  width: 75%;\n  margin: 10px auto;\n}\n\n.example-header-image {\n  background-image: url('https://material.angular.io/assets/img/examples/shiba1.jpg');\n  background-size: cover;\n}\n\n.main-div{\n  /*height: 100vh;*/\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  /*align-items: center;*/\n}\n\n.password {\n  width: 100%;\n}\n\n.buttons {\n  width: 100%;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/srocha/Dropbox/Projects/Charlotte Products/CharlottePasswordReset/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main